var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"min-width":"0","padding":"0"},attrs:{"color":"primary","loading":_vm.loading,"disabled":_vm.disabled,"text":"","small":""},on:{"click":function($event){return _vm.btnAdd_OnClick()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-plus-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }